<template>
  <v-hover v-slot:default="{ hover }">
    <v-card
      @click="$emit('click', icon)"
      :color="(hoverBehavior && hover) ? colorOnHover : backgroundColor"
      :style="cardStyle"
      :dark="dark"
      :elevation="elevation"
    >
      <v-tooltip top :disabled="!textOnMouseOver">
        <template v-slot:activator="{ on }">
          <v-layout
            :class="`${contentPadding ? contentPadding : 'px-2 py-1'}`"
            :justify-center="!title"
            v-on="on"
          >
            <div class="my-auto py-0">
              <v-avatar v-if="image && !icon">
                <img :src="image.url" :style="image.style" />
              </v-avatar>
              <v-btn v-else-if="avatar && icon && !image" color="accent" elevation="3" fab small>
                <v-icon>{{ icon }}</v-icon>
              </v-btn>
              <v-layout v-else-if="icon && !image" column align-center justify-center fill-height>
                <v-icon x-large class="mr-2" :color="iconColor">{{ icon }}</v-icon>
              </v-layout>
            </div>
            <v-layout column class="card-format my-auto ml-1 pa-1">
              <span :class="`${titleClass} pb-0 card-format`" :style="titleStyle">{{ title }}</span>
              <span class="pt-0 mt-0 card-format">{{ subtitle }}</span>
            </v-layout>
          </v-layout>
        </template>
        <span v-if="textOnMouseOver">{{ textOnMouseOver }}</span>
      </v-tooltip>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  props: {
    image: Object,
    elevation: String,
    borderRadius: String,
    icon: String,
    iconColor: String,
    subtitle: String,
    textOnMouseOver: String,
    titleClass: String,
    titleStyle: String,
    title: String,
    contentPadding: String,
    backgroundColor: { type: String, required: true },
    colorOnHover: { type: String, default: 'white' },
    dark: { type: Boolean, default: false },
    avatar: { type: Boolean, default: false },
    hoverBehavior: { type: Boolean, default: false },
  },

  computed: {
    cardStyle() {
      return {
        'border-radius': this.borderRadius,
      };
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}

.card-format {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
